const RELOAD_ATTEMPTS_KEY = 'misrutas_deploy_reload_attempts';
const POLL_MS = 5 * 60 * 1000;

let watcherStarted = false;

function versionJsonPath(): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  if (!base) {
    return '/version.json';
  }
  return `${base}/version.json`;
}

/**
 * Si el servidor expone un build distinto al del bundle, recarga la pestaña
 * para obtener el nuevo index.html y los JS con hash nuevos.
 * Recomendación de despliegue: Cache-Control no-cache (o corto) en index.html y version.json.
 */
export function startDeployVersionWatcher(): void {
  if (watcherStarted) {
    return;
  }
  watcherStarted = true;

  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const embedded = process.env.REACT_APP_BUILD_STAMP;
  if (!embedded || embedded === 'development') {
    return;
  }

  const check = async () => {
    try {
      const url = `${versionJsonPath()}?t=${Date.now()}`;
      const res = await fetch(url, { cache: 'no-store' });
      if (!res.ok) {
        return;
      }
      const data = (await res.json()) as { build?: string };
      const remote = String(data.build || '');
      if (!remote) {
        return;
      }

      if (remote === embedded) {
        sessionStorage.removeItem(RELOAD_ATTEMPTS_KEY);
        return;
      }

      const attempts = Number(sessionStorage.getItem(RELOAD_ATTEMPTS_KEY) || '0');
      if (attempts >= 3) {
        return;
      }
      sessionStorage.setItem(RELOAD_ATTEMPTS_KEY, String(attempts + 1));
      window.location.reload();
    } catch {
      /* red o CORS: ignorar */
    }
  };

  void check();
  window.setInterval(() => void check(), POLL_MS);
}
